import { createEpicMiddleware, combineEpics } from 'redux-most';
import createPrivacyOptIn from './epics/privacy/optIn';
import createPrivacyOptOut from './epics/privacy/optOut';
import createPrivacySubmitForm from './epics/privacy/form';
import { dismissRibbonEpic } from './epics/privacy/ribbon';
import createBootstrapEpic from './epics/privacy/bootstrap';

export default function composition({
  optInRepo,
  optOutRepo,
  saveInteraction,
  fetchOptsRepo,
  emitEvent,
  cleanseRepo,
}) {
  const submitForm = createPrivacySubmitForm(saveInteraction);
  const privacyOptIn = createPrivacyOptIn(
    optInRepo,
    cleanseRepo,
    emitEvent,
  );
  const privacyOptOut = createPrivacyOptOut(
    optOutRepo,
    emitEvent,
    cleanseRepo,
  );
  const bootstrap = createBootstrapEpic(fetchOptsRepo);

  const epics = combineEpics([
    submitForm,
    privacyOptIn,
    privacyOptOut,
    dismissRibbonEpic,
    bootstrap,
  ]);

  const epicMiddleware = createEpicMiddleware(epics);

  return {
    epicMiddleware,
  };
}


// WEBPACK FOOTER //
// ./src/application/composition.js